import {CAC_DEFAULT_OPTIONS, CustomApiController} from 'extensions/ui-controllers/custom-api';

/**
 * Used to cache the sales brands response and provide to any other web-component later if called
 * @type {string[]}
 */
let salesBrands = void 0;

export class SalesBrandsController {
	constructor (host, options = CAC_DEFAULT_OPTIONS) {
		// Add controller to host
		(this.host = host).addController(this);

		/**
		 * @type {CustomApiController}
		 */
		this.customApiController = new CustomApiController(host, options);
	}

	async getSalesBrands () {
		if (!salesBrands) {
			// Get sale brands
			const saleBrandsResponse = await this.customApiController.send('load-components-layouts-layout-json', {
				// eslint-disable-next-line camelcase
				Layout_Code: 'toggle_discount'
			});

			// Set salesBrands hoisted variable for future calls to bypass the fetch
			// eslint-disable-next-line require-atomic-updates
			salesBrands = saleBrandsResponse?.data?.map(brand => brand.name);
		}

		return salesBrands;
	}
};

